import { render, staticRenderFns } from "./ProCard.vue?vue&type=template&id=5817c0d6&scoped=true"
import script from "./ProCard.vue?vue&type=script&lang=js"
export * from "./ProCard.vue?vue&type=script&lang=js"
import style0 from "./ProCard.vue?vue&type=style&index=0&id=5817c0d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5817c0d6",
  null
  
)

export default component.exports